"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InjectCore = void 0;
var _inject = require("./redux/inject");
var _constants = require("../utils/constants");
var _sagas = require("./redux/sagas");
const InjectCore = _ref => {
  let {
    children
  } = _ref;
  (0, _inject.useInjectSaga)({
    key: _constants.packageKey,
    saga: _sagas.coreSaga
  });
  return children;
};
exports.InjectCore = InjectCore;